import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import {
  WorksheetChartSection,
  WorksheetResultsSection,
  WorksheetsResultsMessagesSection,
} from 'Components/Worksheets/Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import React from 'react';
import ResultsCalculatedPropertiesSection from './ResultsCalculatedPropertiesSection';
import ResultsChartOptionsSection from './ResultsChartOptionsSection';
import ResultsReportOptionsSection from './ResultsReportOptionsSection';
let ResultsPageSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  return (
    <WorksheetResultsSection heading="Results">
      <ResultsChartOptionsSection />
      <NamePrefixModifier namePrefix="chart">
        <WorksheetChartSection wide />
      </NamePrefixModifier>
      <WorksheetsResultsMessagesSection />
      <ResultsCalculatedPropertiesSection />
      <ResultsReportOptionsSection />
    </WorksheetResultsSection>
  );
};

ResultsPageSection = withInjectedProps(ResultsPageSection);

export { ResultsPageSection };
export default ResultsPageSection;
